import React from "react";
import PageHero from "../components/PageHero";
import { company } from "../mock";

export default function PrivacyPolicy() {
  return (
    <main>
      <PageHero
        eyebrow="Legal"
        title="Privacy Policy"
        subtitle="How Apex Quality Consultancy collects, uses and protects personal information."
        breadcrumb={[{ label: "Privacy Policy" }]}
      />

      <section className="py-16 md:py-20">
        <div className="container-x max-w-4xl">
          <div className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed">
            <p className="text-sm text-slate-500">Last updated: 2026</p>

            <h2 className="text-2xl font-bold text-navy mt-8">1. Introduction</h2>
            <p>
              {company.legalName} (“Apex Quality Consultancy”, “we”, “us”, “our”) respects your privacy and is
              committed to protecting your personal information in accordance with the Privacy Act 1988 (Cth) and the
              Australian Privacy Principles.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">2. Information we collect</h2>
            <p>We may collect the following types of personal information:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Name, business name, email and phone number</li>
              <li>Business details, registration groups and NDIS provider information</li>
              <li>Information you provide in enquiries, forms or consultations</li>
              <li>Website usage information (IP address, browser, pages visited)</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mt-8">3. How we use your information</h2>
            <p>We use personal information to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Respond to enquiries and provide requested services</li>
              <li>Prepare and deliver consultancy and documentation services</li>
              <li>Communicate updates relevant to your engagement</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy mt-8">4. Disclosure of information</h2>
            <p>
              We do not sell personal information. We may disclose information to service providers who assist us in
              operating our business (e.g. document delivery, IT services), or where required by law. Where we engage
              accredited NDIS auditors or compliance professionals on your behalf, relevant information may be shared
              with your prior consent.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">5. Data security</h2>
            <p>
              We take reasonable steps to protect personal information from misuse, loss, unauthorised access,
              modification or disclosure. However, no method of electronic transmission or storage is fully secure.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">6. Access and correction</h2>
            <p>
              You may request access to or correction of personal information we hold about you by contacting us at
              {' '}<a href={`mailto:${company.email}`} className="text-teal underline">{company.email}</a>.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">7. Cookies and website data</h2>
            <p>
              Our website may use cookies and similar technologies to improve user experience. You may disable cookies
              in your browser settings, although some functionality may be affected.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">8. Changes to this policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Updates will be published on this page with a
              revised “Last updated” date.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8">9. Contact us</h2>
            <p>
              For privacy questions or complaints, contact us at
              {' '}<a href={`mailto:${company.email}`} className="text-teal underline">{company.email}</a> or call {company.phone}.
            </p>

            <div className="mt-10 p-5 bg-mist rounded-xl border border-slate-200 text-sm">
              <p className="font-semibold text-navy">{company.legalName}</p>
              <p>ABN: {company.abn} | ACN: {company.acn}</p>
              <p>{company.address}</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
